import {Box, Grid, Typography} from '@mui/material';
import {useEffect, useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {useDispatch} from 'react-redux';
import CustomisedButton from '../../../../components/button/button';
import PriceFeild from '../../../../components/textField/priceFeild';
import CustomisedTitleFont14 from '../../../../components/title/titleFont14';
import {GUARANTOR_INFO} from '../../../../config/cacheKey';
import {
    GetGuaranteedLoansResponse,
    ILoans,
} from '../../../../models/guarantor.model';
import {
    changeRouteType,
    getpervInnerState,
} from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import {setHeaderTitle} from '../../../../redux/headerTitle/headerTitleSlice';
import {GetGuaranteedLoans} from '../../../../services/guarantor.service';
import EmptyPageStyle from '../../../emptyPageStyle/emptyPageStyle';
import LoansSkeleton from '../../loansTab/Loans/loansSkeleton';
import {IInnerStateHomeMenu} from '../IHomeMenu';
import './newPayment.css';
import CustomisedTextField from '../../../../components/textField/textField';
import InstallmentCard from './installmentCard';
import {set} from 'lodash';
import NewpaymentSkeleton from './newpaymentSkeleton';
import PaymentReceipt from '../../../../components/card/paymentReceipt/paymentReceipt';
import {
    GetSentToBankLoanRequestsForCurrentUser,
    PayArrearsPayment,
} from '../../../../services/payment.service';
import {IGetSentToBankLoanRequestsForCurrentUserResponse} from '../../../../models/payment.model';
export default function NewPayment({setState}: IInnerStateHomeMenu) {
    const [data, setData] =
        useState<IGetSentToBankLoanRequestsForCurrentUserResponse[]>();
    const [selectedId, setSelectedId] = useState<string>();
    const [amount, setAmount] = useState<string>();
    const dispatch = useDispatch();
    const randomKeyForDispatch = Math.random();
    const queryClient = useQueryClient();

    const handlePayment = (guarantorInfo: ILoans) => {
        queryClient.setQueryData(GUARANTOR_INFO, guarantorInfo);
        // setState!('guarantorDetail');
    };
    //services
    const {mutateAsync: loanRequesteListMutate, isLoading} = useMutation(
        GetSentToBankLoanRequestsForCurrentUser,
        {
            onSuccess: (data) => {
                setData(data);
            },
        }
    );
    const {mutateAsync: payArrearsPaymentMutate} = useMutation(
        PayArrearsPayment,
        {
            onSuccess: (data) => {
                if (data?.redirectionToBankUrl) {
                    window.location.href = data.redirectionToBankUrl;

                    // window.open(data.redirectionToBankUrl, '_blank');
                } else {
                    console.error('Bank URL not found in response');
                }
            },
            onError: (error) => {
                console.error('Payment failed', error);
            },
        }
    );
    //services
    useEffect(() => {
        dispatch(
            setHeaderTitle({
                color: 'var(--header-color)',
                header: 'پرداختی جدید',
                parentRoute: 'home',
            })
        );
        dispatch(changeRouteType({routeType: 'child'}));
        dispatch(
            getpervInnerState({prevInnerState: `home ${randomKeyForDispatch}`})
        );
        loanRequesteListMutate();
    }, []);

    const handleContinue = () => {
        var callBack = window.location.origin;
        payArrearsPaymentMutate({
            referenceKey: selectedId!,
            amount: Number(amount?.replace(/,/g, '')),
            callBack,
        });
    };

    const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const rawValue = e.target.value.replace(/,/g, '');
        if (!/^\d*$/.test(rawValue)) return;
        if (rawValue === '') {
            setAmount('');
        } else {
            const formattedValue = Number(rawValue).toLocaleString('en-US');
            setAmount(formattedValue);
        }
    };

    if (isLoading) {
        return <NewpaymentSkeleton />;
    }
    return (
        <div className="px-5 py-8 md:py-4">
            {data && data.length > 0 ? (
                <Grid
                    container
                    sx={{
                        height: '100%',
                        marginY: '20px',
                        overflowX: 'hidden',
                    }}
                    className="container-height-without-drawer"
                >
                    <Typography
                        sx={{textAlign: 'justify'}}
                        className="primaryColorLight-900"
                    >
                        لطفا برای پرداخت معوقات، تسهیلات مربوطه را انتخاب کرده و
                        مبلغ مورد نظر را در کادر زیر وارد کنید.
                    </Typography>
                    <Typography
                        sx={{textAlign: 'justify', marginBottom: '10px'}}
                        className="primaryColorLight-900"
                    >
                        پرداخت از طریق تمامی کارتهای عضو شتاب امکان پذیر است.
                    </Typography>
                    {/* <PaymentReceipt /> */}
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            marginBottom: '175px',
                        }}
                    >
                        {data?.map((option) => (
                            <Grid item xs={12} key={option.referenceKey}>
                                <InstallmentCard
                                    selected={
                                        selectedId === option.referenceKey
                                    }
                                    onSelect={() =>
                                        setSelectedId(option.referenceKey)
                                    }
                                    financialSupplierTitle={
                                        option.financialSupplierTitle
                                    }
                                    repaymentTitle={option.repaymentTitle}
                                    loanTemplateTitle={option.loanTemplateTitle}
                                    duration={`${option.durationByMonth} ماه با فاصله قسط ${option.stepSpaceByMonth} ماه`}
                                    status={option.loanRequestStatusPersian}
                                    amount={option.firstInstallmentAmount}
                                />
                            </Grid>
                        ))}
                    </Grid>
                    <Box
                        className="fixedView "
                        sx={{background: 'var(--bg-color)'}}
                    >
                        <Typography
                            style={{
                                padding: '0.8rem 0',
                                borderTop: '1.2px solid #D7DBEC',
                            }}
                        >
                            <CustomisedTitleFont14
                                title={'مبلغ قابل پرداخت (ريال)* '}
                            />
                        </Typography>

                        <div>
                            <CustomisedTextField
                                label=" مبلغ"
                                placeholder={''}
                                required={true}
                                inputProps={{type: 'tel'}}
                                value={amount}
                                onChange={handleAmountChange}
                                name="amount"
                                id="amount"
                            />
                        </div>

                        <div className="mt-5">
                            <CustomisedButton
                                title="پرداخت"
                                disable={!amount || !selectedId}
                                onClick={handleContinue}
                                type="button"
                            />
                        </div>
                    </Box>
                </Grid>
            ) : (
                <EmptyPageStyle
                    prefixText="تسهیلاتی"
                    highlightedText=" یافت"
                    suffixText="نشد"
                />
            )}
            {/* : <EmptyPageStyle prefixText="پرداختی" highlightedText=" ثبت" suffixText=" نشده است" />} */}
        </div>
    );
}
